import PictureHtml from './picture-html';
import PlaceholderImageHtml from './placeholder-image-html';

export default class ProductCardHtml {
    constructor(url, id, title, data, image, productCartButton) {
        this._url = url;
        this._id = id;
        this._title = title;
        this._data = data;
        this._image = image;
        this._productCartButton = productCartButton;
    }

    _getImageHtml() {
        const $globalConfig = config;

        if (this._image && this._image.identifier && this._image.identifier !== '') return new PictureHtml(this._image.WEBXS, this._image.WEBMD, this._image.WEBLG, this._image.alternateName, 'rfct-product-card__image').toString();

        if ('objectFit' in document.documentElement.style === false) {
            return `<div class="rfct-product-card__image__content-ie">
                ${new PlaceholderImageHtml(16, 9, $globalConfig).toString()}
            </div>`;
        }

        return `<div class="rfct-product-card__image__content">
            ${new PlaceholderImageHtml(16, 9).toString()}
        </div>`;
    }

    _getHeaderHtml() {
        // eslint-disable-next-line no-undef
        const $globalConfig = config;

        return `
            <div class="rfct-product-card__header">
                <div class="rfct-product-card__header-subline">
                    <span class="rfct-product-card__header-subline-text">${$globalConfig.textResources.productCatalogConnectorConfig.labelArticleNumber} ${this._id}</span>
                </div>
                <span class="rfct-product-card__header-title">${this._title}</span>
            </div>
        `;
    }

    _getContentHtml() {
        let tbody = '';
        if (this._data) {
            this._data.forEach((e) => {
                tbody += `<tr><td>${e.key}</td><td>${e.value}</td>`;

                if (e.additionalValue) {
                    tbody += `<td>${e.additionalValue}</td>`;
                }

                tbody += '</tr>';
            });
        }

        return `
            <div class="rfct-product-card__content">
                <table class="table mt-3 rfct-table rfct-table--striped">
                    ${tbody}
                </table>
            </div>
        `;
    }

    _getButtonHtml() {
        return `
            <div class="rfct-product-card__buttons">
                <div class="rfct-product-card__button-item">
                    ${this._productCartButton}
                </div>
            </div>
        `;
    }

    toString() {
        return `
            <a class="rfct-product-card" href="${this._url}">
                <div class="rfct-product-card__inner">
                    ${this._getHeaderHtml()}
                    ${this._getImageHtml()}
                    ${this._getContentHtml()}
                    ${this._getButtonHtml()}
                </div>
            </a>
        `;
    }
}
